import { Stats } from "../../../state/types";
import { ITooltip } from "../util";
import {
  CONTRIBUTION_LEGEND,
  DIMENSIONS,
  LIVABILITY_LEGEND,
  parcelLivability,
} from "./livabilityLegend";
import { StatScores } from "./StatScores";

// Buurt: `score` is de afwijking van het landelijk gemiddelde, de dimensies
// staan onder hun lange naam
const neighbourhoodMapping = Object.fromEntries(DIMENSIONS.map((d) => [d.stat, d.label]));
const parcelMapping = Object.fromEntries(DIMENSIONS.map((d) => [d.short, d.label]));

export const Livability = ({ stats }: { stats: Stats }) => (
  <StatScores
    stats={stats}
    mapping={neighbourhoodMapping}
    title="Leefbaarheid wijk"
    legend={LIVABILITY_LEGEND}
    subLegend={CONTRIBUTION_LEGEND}
  />
);

/**
 * De Leefbaarometer per 100 m-cel, gemiddeld over het perceel. Ontbreekt waar
 * minder dan vijf mensen wonen (privacy); dan staat alleen de wijk er.
 */
export const ParcelLivability = ({ rast }: { rast: Record<string, unknown> | undefined }) => {
  const livability = parcelLivability(rast);
  if (!livability) return null;
  const { afw, ...dimensions } = livability;
  return (
    <StatScores
      stats={{ score: afw, ...dimensions }}
      mapping={parcelMapping}
      title="Leefbaarheid op perceel"
      legend={LIVABILITY_LEGEND}
      subLegend={CONTRIBUTION_LEGEND}
      info={
        <ITooltip content="Leefbaarometer 3.0 per 100 × 100 m. Een modeluitkomst die de omgeving tot ongeveer 1 km meeweegt, geen kenmerk van dit perceel alleen." />
      }
    />
  );
};
